<template>
    <div class="appr-page">
        <!-- 查询段 -->
        <div class="query-box mb10">
            <el-form inline :model="formData" size="mini" class="filter-bar">
                <el-form-item>
                    <CustomInput label="关键词">
                        <el-input v-model="formData.search" placeholder="工单名" clearable size="mini" style="width:150px"/>
                    </CustomInput>
                </el-form-item>
                <el-form-item>
                    <CustomInput label="申请类型">
                        <SelectAll :options="typeOptions" v-model="formData.apply_type" :multiple="false" placeholder="全部"/>
                    </CustomInput>
                </el-form-item>
                <el-form-item>
                    <CustomInput label="审批状态">
                        <SelectAll :options="statusOptions" v-model="formData.approve_status" :multiple="false" placeholder="全部"/>
                    </CustomInput>
                </el-form-item>
                <el-form-item>
                    <CustomInput label="申请时间">
                        <el-date-picker v-model="ctimeRange" type="daterange" value-format="yyyy-MM-dd"
                                        range-separator="~" start-placeholder="开始" end-placeholder="结束"
                                        size="mini" style="width:240px" clearable/>
                    </CustomInput>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="mini" @click="handleSearch">查询</el-button>
                    <el-button size="mini" @click="handleReset">重置</el-button>
                </el-form-item>
            </el-form>
        </div>

        <!-- 子tab栏 -->
        <ObliqueTags v-if="tabTags.length" :tags="tabTags" :value="activeTab" @tab-click="v=>$emit('tab-switch', v)"/>

        <!-- 表格段 -->
        <div class="bg-white pt10 pl10 pr10 pb10 borderRadius5">
            <div class="operation-box mb10">
                <div class="operation-left">
                    <el-button size="mini" icon="el-icon-refresh" @click="refresh">刷新</el-button>
                    <span class="op-tip">运营置换：换自己单→仅创意负责人审批；换别人运营的单→<b>被换运营 + 创意负责人双签</b>（权责对等）。改落点申请→<b>创意负责人单签</b>（改组/日期·排期日已过走此修日期）。下单超产能→<b>创意负责人单签</b>（通过时安排制作组+交付日落点）。列出全部申请；你为会签人的可通过/驳回，其余只读。</span>
                </div>
            </div>

            <div class="batch-bar mb10" v-if="hasApprovalOp">
                <span class="bb-cnt">已选 <b>{{selection.length}}</b> 条</span>
                <el-button type="success" size="mini" :disabled="!selection.length" @click="openDecide(null, true)">批量通过</el-button>
                <el-button type="danger" size="mini" :disabled="!selection.length" @click="openDecide(null, false)">批量驳回</el-button>
                <span class="bb-tip op-tip">仅勾选「待你会签」的申请生效</span>
            </div>

            <jt-table :key="'appr'" v-loading="loading" :data="list" border stripe
                      header-cell-class-name="header-cell"
                      @selection-change="onSelectionChange" style="width:100%">
                <el-table-column type="selection" align="center" width="46" :selectable="row=>canDecide(row)"/>
                <el-table-column label="工单 / 项目" align="left" min-width="170">
                    <template slot-scope="{row}">
                        <div class="oname">#{{row.order_id}} {{row.order_name||'—'}}</div>
                        <div class="oproj">{{ row.category_group_name || '—' }}<span v-if="row.group_name"> · {{ row.group_name }}</span></div>
                    </template>
                </el-table-column>
                <el-table-column label="申请类型" align="center" width="100">
                    <template slot-scope="{row}">
                        <el-tag size="mini" type="warning" effect="plain">{{ row.apply_type_text || '运营置换' }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="申请内容" align="left" min-width="180">
                    <template slot-scope="{row}">{{ payloadText(row) }}</template>
                </el-table-column>
                <el-table-column label="申请人" align="center" width="90">
                    <template slot-scope="{row}">{{ row.apply_name || row.apply_uid || '—' }}</template>
                </el-table-column>
                <el-table-column label="申请时间" align="center" width="140">
                    <template slot-scope="{row}">{{ fmtTime(row.ctime) || '—' }}</template>
                </el-table-column>
                <el-table-column prop="apply_reason" label="申请理由" align="left" min-width="110" class-name="ec-reason">
                    <template slot-scope="{row}">{{ row.apply_reason || '—' }}</template>
                </el-table-column>
                <!-- 双签状态 -->
                <el-table-column label="双签会签" align="left" width="190">
                    <template slot-scope="{row}">
                        <div class="sign-line">
                            <span class="sign-k">运营方</span>
                            <el-tag size="mini" :type="statusTagType(row.ops_approve_status)">{{ row.ops_approve_status_text || '待审' }}</el-tag>
                            <span class="sign-u">{{ row.ops_approver_name || '' }}</span>
                        </div>
                        <div class="sign-line">
                            <span class="sign-k">审批人</span>
                            <el-tag size="mini" :type="statusTagType(row.creative_approve_status)">{{ row.creative_approve_status_text || '待审' }}</el-tag>
                            <span class="sign-u">{{ row.creative_approver_name || '' }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="总状态" align="center" width="84">
                    <template slot-scope="{row}">
                        <el-tag size="mini" :type="statusTagType(row.approve_status)">{{ row.approve_status_text || statusText(row.approve_status) }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="140" fixed="right">
                    <template slot-scope="{row}">
                        <template v-if="canDecide(row)">
                            <el-button type="text" size="mini" class="text-color-success" @click="openDecide(row, true)">通过</el-button>
                            <el-button type="text" size="mini" class="text-color-danger" @click="openDecide(row, false)">驳回</el-button>
                        </template>
                        <span v-else-if="row.approve_status==0" class="op-tip">{{ mySigned(row) ? '你已签·待对方' : '待审批' }}</span>
                        <span v-else class="op-tip">已处理</span>
                    </template>
                </el-table-column>
            </jt-table>

            <div class="tar mt10">
                <el-pagination background layout="total, prev, pager, next, sizes" :total="total"
                               :current-page="formData.page" :page-size="formData.page_size" :page-sizes="[20,50,100]"
                               @current-change="onPageChange" @size-change="onSizeChange"/>
            </div>
        </div>

        <!-- 审批意见 弹框 -->
        <el-dialog :title="decidePass ? '通过会签' : '驳回会签'" :visible.sync="decideDialog" width="440px" append-to-body>
            <div class="edit-info" v-if="decideRow">
                <div><span class="k">工单：</span><b>#{{decideRow.order_id}} {{decideRow.order_name||'—'}}</b></div>
                <div><span class="k">申请：</span>{{ typeText(decideRow.apply_type) }} · {{ payloadText(decideRow) }}</div>
            </div>
            <div class="edit-info" v-else>批量{{ decidePass ? '通过' : '驳回' }} <b>{{selection.length}}</b> 条（仅你可会签生效）。</div>
            <p class="mb6 dialog-tip" v-if="decidePass">
                <template v-if="decideRow && Number(decideRow.apply_type)===3">下单超产能=<b>创意负责人单签</b>，通过时请安排<b>制作组 + 交付日</b>，通过即落点（待排单→已排单）；驳回则单留在待排单可后续手动落点。</template>
                <template v-else-if="decideRow && Number(decideRow.apply_type)===2">改落点申请=<b>创意负责人单签</b>，你通过即落地（写组+交付日）。</template>
                <template v-else>通过=你这一方签字；<b>两签皆通过才真换组生效</b>。任一方驳回则整单驳回。</template>
            </p>
            <!-- 下单超产能(type=3)通过：审批人选制作组 + 交付日落点 -->
            <div class="oc-decide" v-if="decidePass && decideRow && Number(decideRow.apply_type)===3">
                <div class="oc-reason"><span class="k">强制原因：</span>{{ decideRow.apply_reason || '—' }}</div>
                <el-form label-width="76px" size="small" class="mt6">
                    <el-form-item label="制作组" required>
                        <el-select v-model="decideForm.group_id" filterable placeholder="选择制作组（按产能配置过滤）" style="width:100%">
                            <el-option-group label="同素材类型">
                                <el-option v-for="g in ocSameCat" :key="g.id" :label="g.name+'（'+g.parent_name+'）'" :value="g.id"/>
                            </el-option-group>
                            <el-option-group label="跨大类 · 破例">
                                <el-option v-for="g in ocCrossCat" :key="g.id" :label="g.name+'（'+g.parent_name+'）· 跨大类'" :value="g.id"/>
                            </el-option-group>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="交付日" required>
                        <el-date-picker v-model="decideForm.delivery" type="date" value-format="yyyy-MM-dd"
                            :picker-options="deliveryPickerOptions" placeholder="选择交付日（不早于今天·封顶 T+N）" style="width:100%"/>
                    </el-form-item>
                </el-form>
            </div>
            <el-input v-model="decideRemark" type="textarea" :rows="2" :placeholder="decidePass ? '审批意见（选填）' : '驳回原因（建议填写）'"/>
            <span slot="footer">
                <el-button @click="decideDialog=false">取消</el-button>
                <el-button :type="decidePass?'primary':'danger'" :loading="decideLoading" @click="doDecide">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import API from '@/api/workOrder/approval.js';
    import scheduleManageAPI from '@/api/workOrder/scheduleManage.js';
    import SelectAll from '@/components/SelectAll';
    import ObliqueTags from '@/views/workOrder/components/obliqueTags.vue';

    export default {
        name: 'ApprovalPage',
        components: { SelectAll, ObliqueTags },
        props: {
            pageFuncNames: { type: Array, default: () => [] },
            tabTags: { type: Array, default: () => [] },
            activeTab: { type: String, default: '' },
        },
        data() {
            return {
                loading: false,
                list: [],
                total: 0,
                selection: [],
                typeMap: {}, statusMap: {},
                typeOptions: [], statusOptions: [],
                leafMap: {},
                leafGroups: [], // type=3 超产能审批落点·制作组扁平列表
                ctimeRange: [], // 申请时间筛选区间 [start,end]（yyyy-MM-dd）
                formData: this.defaultForm(),
                decideDialog: false,
                decideRow: null,
                decidePass: true,
                decideRemark: '',
                decideLoading: false,
                // 下单超产能(type=3)通过时审批人填的落点
                decideForm: { group_id: '', delivery: '' },
            };
        },
        mounted() {
            this.loadOptions();
            this.loadLeafGroups();
            this.getList();
        },
        computed: {
            // 审批操作权（wos_approval）——去操作权后审批 tab/列表仍可看(只读)，仅通过/驳回按钮受此门控·BUG-002-AT
            hasApprovalOp() { return (this.pageFuncNames || []).includes('wos_approval'); },
            // 超产能(type=3)审批落点：本单大类(category_group_id)
            ocCatId() { return this.decideRow ? Number(this.decideRow.category_group_id || 0) : 0; },
            // 同大类制作组（p_group_id == 本单大类）·已按产能配置(only_capacity)过滤
            ocSameCat() {
                return this.leafGroups.filter(g => this.ocCatId && Number(g.p_group_id) === this.ocCatId);
            },
            // 跨大类制作组（破例·审批人可选）
            ocCrossCat() {
                return this.leafGroups.filter(g => !this.ocCatId || Number(g.p_group_id) !== this.ocCatId);
            },
            // 交付日限制：不早于今天（上限 T+N 由后端 assertDeliveryWithinCeiling 兜底拦截）
            deliveryPickerOptions() {
                return { disabledDate: d => d.getTime() < Date.now() - 86400000 };
            },
        },
        methods: {
            defaultForm() {
                return { page: 1, page_size: 20, search: '', apply_type: '', approve_status: '' };
            },
            // 当前用户能否会签该申请的某一方（有待签方且是本人）
            canDecide(row) { return this.hasApprovalOp && Number(row.approve_status) === 0 && (Number(row.my_ops_pending) === 1 || Number(row.my_creative_pending) === 1); },
            mySigned(row) {
                // 我是会签人但本方已签（非 pending）
                return !this.canDecide(row);
            },
            typeText(v) { return this.typeMap[v] || '运营置换'; },
            statusText(v) { return this.statusMap[v] || '—'; },
            statusTagType(s) { return { 0: 'info', 1: 'success', 2: 'danger' }[s] || 'info'; },
            fmtTime(sec) {
                if (!sec) return '';
                const d = new Date(sec * 1000);
                const p = n => (n < 10 ? '0' + n : '' + n);
                return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()) + ' ' + p(d.getHours()) + ':' + p(d.getMinutes());
            },
            payloadText(row) {
                let p = {};
                try { p = JSON.parse(row.apply_payload || '{}'); } catch (e) { p = {}; }
                const gn = this.leafMap[p.group_id] || ('组' + (p.group_id || '?'));
                const st = Number(p.swap_target_order_id || row.swap_target_order_id || 0);
                if (Number(row.apply_type) === 3) { // 下单超产能：落点由审批人在通过时定
                    return '超产能强制下单 · 待审批人安排制作组 + 交付日';
                }
                if (Number(row.apply_type) === 2) { // 改落点申请：组 + 交付日
                    return '改落点 → ' + gn + (p.delivery ? ' @ ' + p.delivery : '');
                }
                return st > 0 ? ('置换：与 #' + st + ' 互换组') : ('换组 → ' + gn);
            },
            async loadOptions() {
                try {
                    const { data } = await API.getOptions({});
                    this.typeOptions = (data.apply_type || []).map(o => ({ value: o.v, label: o.name }));
                    this.statusOptions = (data.approve_status || []).map(o => ({ value: o.v, label: o.name }));
                    this.typeMap = this.toMap(data.apply_type);
                    this.statusMap = this.toMap(data.approve_status);
                } catch (e) { /* ignore */ }
            },
            toMap(arr) {
                const m = {};
                (arr || []).forEach(o => { m[o.v] = o.name; });
                return m;
            },
            async loadLeafGroups() {
                try {
                    // only_capacity=1：仅返产能配置过的组（按操作档），与 boardSchedule 同口径
                    // v4 BUG-002-BT：走排单管理 tab 节点的 schedule_manage/group_options，别改回 ConfAPI.getSchedulingGroups(挂产能配置节点·不勾即 403)
                    const { data } = await scheduleManageAPI.groupOptions({ only_capacity: 1 });
                    const map = {};
                    const flat = [];
                    const walk = (nodes, parentName) => {
                        (nodes || []).forEach(n => {
                            map[n.id] = n.name;
                            if (n.is_leaf == 1) flat.push({ id: n.id, name: n.name, parent_name: parentName || '', p_group_id: n.p_group_id });
                            if (n.children && n.children.length) walk(n.children, n.name);
                        });
                    };
                    walk(data || [], '');
                    this.leafMap = map;
                    this.leafGroups = flat; // type=3 超产能审批落点选制作组用
                } catch (e) { /* ignore */ }
            },
            async getList() {
                this.loading = true;
                try {
                    const r = this.ctimeRange || [];
                    const { data } = await API.getList({ ...this.formData, ctime_start: r[0] || '', ctime_end: r[1] || '' });
                    this.list = data.list || [];
                    this.total = data.total || 0;
                } catch (error) {
                    this.$message.error((error && error.info) || '加载失败');
                } finally {
                    this.loading = false;
                }
            },
            refresh() { this.selection = []; this.getList(); },
            handleSearch() { this.formData.page = 1; this.getList(); },
            handleReset() {
                const ps = this.formData.page_size;
                this.formData = { ...this.defaultForm(), page_size: ps };
                this.ctimeRange = [];
                this.getList();
            },
            onPageChange(p) { this.formData.page = p; this.getList(); },
            onSizeChange(s) { this.formData.page_size = s; this.formData.page = 1; this.getList(); },
            onSelectionChange(val) { this.selection = val; },
            openDecide(row, pass) {
                if (!row && !this.selection.length) { this.$message.warning('请先勾选'); return; }
                this.decideRow = row;
                this.decidePass = pass;
                this.decideRemark = '';
                this.decideForm = { group_id: '', delivery: '' };
                // 下单超产能(type=3)通过 = 审批人选制作组+交付日落点·确保组列表已加载
                if (row && pass && Number(row.apply_type) === 3 && !this.leafGroups.length) {
                    this.loadLeafGroups();
                }
                this.decideDialog = true;
            },
            async doDecide() {
                this.decideLoading = true;
                try {
                    if (this.decideRow) {
                        const params = { id: this.decideRow.id, remark: this.decideRemark };
                        // 下单超产能(type=3)通过：审批人决定落点（组+大类+交付日）
                        if (this.decidePass && Number(this.decideRow.apply_type) === 3) {
                            if (!this.decideForm.group_id) { this.$message.warning('请选择制作组'); this.decideLoading = false; return; }
                            if (!this.decideForm.delivery) { this.$message.warning('请选择交付日'); this.decideLoading = false; return; }
                            const g = this.leafGroups.find(x => String(x.id) === String(this.decideForm.group_id));
                            params.group_id = this.decideForm.group_id;
                            params.category_group_id = g ? g.p_group_id : '';
                            params.delivery = this.decideForm.delivery;
                        }
                        const fn = this.decidePass ? API.approve : API.reject;
                        const { info } = await fn(params);
                        this.$message.success(info || (this.decidePass ? '已通过' : '已驳回'));
                    } else {
                        let rows = this.selection;
                        // 批量通过：超产能(type3)落点需审批人逐单指定组+交付日，批量给不了 → 过滤跳过并提示；
                        // 批量驳回不受限（不走落点生效），全类型可批。
                        if (this.decidePass) {
                            const oc = rows.filter(r => Number(r.apply_type) === 3);
                            if (oc.length) {
                                rows = rows.filter(r => Number(r.apply_type) !== 3);
                                this.$message.warning(oc.length + ' 单超产能审批需单独通过并指定落点，已跳过');
                            }
                            if (!rows.length) { this.decideLoading = false; this.decideDialog = false; return; }
                        }
                        const ids = rows.map(r => r.id).join(',');
                        const fn = this.decidePass ? API.batchApprove : API.batchReject;
                        const { data } = await fn({ ids, remark: this.decideRemark });
                        let m = '成功 ' + (data.done || 0) + ' 条';
                        if (data.fail) m += '，失败 ' + data.fail;
                        if (data.skipped) m += '，跳过 ' + data.skipped + '（超产能需单独通过）';
                        this.$message.success(m);
                    }
                    this.decideDialog = false;
                    this.refresh();
                    // 审批后待审数量变化 → 通知父组件重拉 tab_counts（否则 tab 徽标留旧值·2026-07-01 修）
                    this.$emit('counts-changed');
                } catch (error) {
                    this.$message.error((error && error.info) || '操作失败');
                } finally {
                    this.decideLoading = false;
                }
            },
        },
    };
</script>

<style scoped lang="scss">
    @import "~@/styles/material_sd.scss";

    .appr-page { padding: 4px 0; }
    .query-box { background: #fff; padding: 20px 10px; border-radius: 4px; }
    .query-box ::v-deep .el-form-item { margin-bottom: 10px; }
    .operation-box { display: flex; justify-content: space-between; align-items: center; }
    .operation-left { display: flex; align-items: center; flex-wrap: wrap; }
    .op-tip { margin-left: 8px; color: #909399; font-size: 12px; }
    .filter-bar { margin-bottom: 4px; }
    .batch-bar { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; background: #eef5ff; border: 1px solid #d4e6ff; border-radius: 4px; padding: 6px 12px; }
    .batch-bar .bb-cnt { font-size: 13px; color: #2b5a8a; }
    .batch-bar .bb-cnt b { color: #409eff; font-size: 14px; }
    .oname { font-weight: 600; color: #303133; }
    .oproj { color: #909399; font-size: 11px; margin-top: 2px; }
    .sign-line { display: flex; align-items: center; gap: 4px; line-height: 1.9; }
    .sign-line .sign-k { color: #909399; font-size: 11px; width: 60px; }
    .sign-line .sign-u { color: #606266; font-size: 11px; }
    .tar { text-align: right; }
    .dialog-tip { line-height: 1.7; color: #606266; margin: 0 0 6px; font-size: 13px; }
    .mb6 { margin-bottom: 6px; }
    .edit-info { background: #f7f9fc; border: 1px solid #ebeef5; border-radius: 4px; padding: 8px 12px; margin-bottom: 12px; line-height: 1.8; font-size: 13px; color: #303133; }
    .edit-info .k { color: #909399; }
    .appr-page ::v-deep .ec-reason .cell { white-space: normal; line-height: 1.6; color: #606266; }
    .appr-page ::v-deep .header-cell { background: #e8eaec !important; color: #333 !important; }
</style>
